module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/toolbar_hide-3e2cd8.svg";